export const TrackingPixel = ({ src }: { src?: string }) => {
    if (!src) return null
    return <img src={src} style={{ display: 'none' }} />
}
